import { z } from 'zod';

import { DiaSemanaEnum, HorarioDoDia } from './enums';
import type { DiaSemana, HorarioDoDiaType } from './enums';

export type ProfessorOutput = {
  id: string;
  usuarioId: string | null;
  nome: string;
  telefone: string | null;
  email: string | null;
  photoUrl: string | null;
  diasDisponiveis: DiaSemana[];
  horarioInicial: HorarioDoDiaType;
  horarioFinal: HorarioDoDiaType;
  capacidadePorHorario: number;
  corAgenda: string;
  observacoes: string | null;
  materiaIds: string[];
};

export const ProfessorCreateInput = z.object({
  nome: z.string().min(1),
  telefone: z.string().optional(),
  email: z.email().optional(),
  photoUrl: z.url().optional(),
  diasDisponiveis: z.array(DiaSemanaEnum).min(1),
  horarioInicial: HorarioDoDia,
  horarioFinal: HorarioDoDia,
  capacidadePorHorario: z.number().int().positive(),
  corAgenda: z.string(),
  observacoes: z.string().optional(),
  materiaIds: z.array(z.uuid()).min(1),
});

export const ProfessorUpdateInputAdmin = ProfessorCreateInput.partial();

/** Professor editando a si mesmo: o schema não declara os outros campos e o Zod os descarta em silêncio; a UI garante que não apareçam editáveis. */
export const ProfessorUpdateInputSelf = z
  .object({
    telefone: z.string().optional(),
    email: z.email().optional(),
    photoUrl: z.url().optional(),
    observacoes: z.string().optional(),
  })
  .partial();

export type ProfessorOutputType = ProfessorOutput;
export type ProfessorCreateInputType = z.infer<typeof ProfessorCreateInput>;
export type ProfessorUpdateInputAdminType = z.infer<typeof ProfessorUpdateInputAdmin>;
export type ProfessorUpdateInputSelfType = z.infer<typeof ProfessorUpdateInputSelf>;
